import React, { Component } from "react";
import PropTypes from "prop-types";

class TempLoginModal extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired
  };

  state = {
    login: "",
    password: ""
  };

  onLoginChange = ev => this.setState({ login: ev.target.value });
  onPasswordChange = ev => this.setState({ password: ev.target.value });

  render = () => {
    const { onClose } = this.props;
    return (
      <div>
        <div>
          <p>TEMPORARY LOGIN</p>
          <div>
            <input
              type="email"
              value={this.state.login}
              onChange={this.onLoginChange}
              placeholder="login"
            />
          </div>
          <div>
            <input
              value={this.state.password}
              onChange={this.onPasswordChange}
              placeholder="password"
              type="password"
            />
          </div>
        </div>
        <footer>
          <button onClick={() => onClose(this.state)}>LOGIN</button>
        </footer>
      </div>
    );
  };
}

export default TempLoginModal;



// WEBPACK FOOTER //
// ./src/modules/modal/temp-login-modal.js